import React from 'react';
import Loadable from '@/components/common/loadable';

const Tag = Loadable({
  loader: () => import('@/components/tag'),
});

export default () => <Tag />;
